
import { Row, Col, Container, Navbar, Nav } from 'react-bootstrap'
import { useEffect, useState } from 'react'
import { NavLink, Link } from 'react-router-dom'
import { AiFillChrome, AiFillDashboard, AiFillSetting, AiOutlineKey, AiFillBell } from 'react-icons/ai'
import { BsUnlockFill, BsFillPiggyBankFill, BsEnvelopeFill } from 'react-icons/bs'
import {GiFishingSpoon} from 'react-icons/gi'
import { MdGroup } from 'react-icons/md'
import { FaComments } from 'react-icons/fa'
import { useSelector, useDispatch } from 'react-redux'
import { Steps, Hints } from "intro.js-react";
import API from '../api/api'
import Actions from '../redux/actions'
export default function TopBarNav(props) {


    const user = useSelector(state => state.user)
    const [show, setShow] = useState(false)
    const dispatch = useDispatch()

    useEffect(() => {
        setTimeout(() => {
            setShow(true)
        }, 1200)
    }, [])

    const _flipOnboard = async () => {
        const user = await API.flipOnboard()
        dispatch(Actions.setUser(user))
    }



    return (
        <Navbar bg="white" expand="lg" className='shadow'>

            <Container>
                <Navbar.Brand href="/"> <img src={require('../assets/logo.png')} alt="ScamWall Logo" width="30" height="24" />ScamWall</Navbar.Brand>
                <Navbar.Toggle aria-controls="basic-navbar-nav" />
                <Navbar.Collapse id="basic-navbar-nav">
                    <Nav className="me-auto">
                        <NavLink to='/' className={({ isActive }) => (`${isActive ? 'text-primary weight-bold' : 'text-muted'} m-2 noDecoration dashboard-link`)}><AiFillDashboard className='me-2 my-auto align-middle my-auto' style={{ width: '1.2rem', height: '1.2rem' }} />Dashboard</NavLink>
                        <NavLink to='/user' className={({ isActive }) => (`${isActive ? 'text-primary weight-bold' : 'text-muted'} m-2 noDecoration users-link`)}><MdGroup className='me-2 my-auto align-middle my-auto ' style={{ width: '1.2rem', height: '1.2rem' }} />Users</NavLink>
                        <NavLink to='/access' className={({ isActive }) => (`${isActive ? 'text-primary weight-bold' : 'text-muted'} m-2 noDecoration access-link`)}><BsUnlockFill className='me-2 my-auto align-middle my-auto ' style={{ width: '1.2rem', height: '1.2rem' }} />Temp Access</NavLink>
                        <NavLink to='/email' className={({ isActive }) => (`${isActive ? 'text-primary weight-bold' : 'text-muted'} m-2 noDecoration email-link `)}><BsEnvelopeFill className='me-2 my-auto align-middle my-auto ' style={{ width: '1.2rem', height: '1.2rem' }} />Blocked Emails</NavLink>
                        <NavLink to='/phishing' className={({ isActive }) => (`${isActive ? 'text-primary weight-bold ' : 'text-muted'} m-2 noDecoration url-link`)}><GiFishingSpoon className='me-2 my-auto align-middle my-auto ' style={{ width: '1.2rem', height: '1.2rem' }} />Phishing URLs</NavLink>
                        <NavLink to='/suggestion' className={({ isActive }) => (`${isActive ? 'text-primary weight-bold' : 'text-muted'} m-2 noDecoration suggestion-link`)}><FaComments className='me-2 my-auto align-middle my-auto ' style={{ width: '1.2rem', height: '1.2rem' }} />Suggestions</NavLink>
                        {user?.isAffiliate && <NavLink to='/affiliate' className={({ isActive }) => (`${isActive ? 'text-primary weight-bold' : 'text-muted'} m-2 noDecoration suggestion-link`)}><BsFillPiggyBankFill className='me-2 my-auto align-middle my-auto ' style={{ width: '1.2rem', height: '1.2rem' }} />Affiliate Portal</NavLink>}

                        <NavLink to='/settings' className={({ isActive }) => (`${isActive ? 'text-primary weight-bold' : 'text-muted'} m-2 noDecoration`)}><AiFillSetting className='me-2 my-auto align-middle my-auto' style={{ width: '1.2rem', height: '1.2rem' }} />Settings</NavLink>

                    </Nav>
                </Navbar.Collapse>

            </Container>
        </Navbar>


    )
}
